import React, { useState } from 'react'
import SiteHeader from '@comp/site-header'
import SiteFooter from '@comp/site-footer'
import SiteMobileNav from '@comp/site-mobile-nav'

type LayoutProps = {
  children: any
  miniMode?: boolean
}

export default function Layout({ children }: LayoutProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const toggle = () => setIsMenuOpen((open) => !open)
  const close = () => setIsMenuOpen(false)

  return (
    <>
      <SiteHeader isMenuOpen={isMenuOpen} toggleMenu={toggle} />
      <SiteMobileNav isOpen={isMenuOpen} onClose={close} />
      {children}
      <SiteFooter />
    </>
  )
}
